import { render, staticRenderFns } from "./ManageLanding.vue?vue&type=template&id=5e28f5c6&"
import script from "./ManageLanding.vue?vue&type=script&lang=js&"
export * from "./ManageLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports